import React, { useState } from 'react';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { defineMessages, useIntl } from 'react-intl';
import { DialogHeaderBase as DialogHeader } from '@packages/shared/src/ui/Dialog/DialogHeader/DialogHeaderBase.client';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { createPortal } from 'react-dom';
import { ForgottenPasswordForm } from './ForgottenPasswordForm.client';

const messages = defineMessages({
  headline: { id: 'ForgotPasswordModal.headline', defaultMessage: 'Passwort vergessen?' },
});

export const ForgottenPasswordButton = () => {
  const { formatMessage } = useIntl();
  const [forgottenPasswordDialogOpen, setForgottenPasswordDialogOpen] = useState(false);
  const onClose = () => setForgottenPasswordDialogOpen(false);

  return (
    <>
      <Button
        variant="link"
        className="bg-color-transparent focus-visible:!bg-color-transparent hover:!bg-color-transparent hover:text-color-primary-light text-size-body-xs self-start border-0 p-0"
        onClick={() => setForgottenPasswordDialogOpen(true)}
      >
        {formatMessage({
          id: 'ForgotPasswordModal.headline',
          defaultMessage: 'Passwort vergessen?',
        })}
      </Button>
      {forgottenPasswordDialogOpen &&
        createPortal(
          <Dialog className="h-full lg:max-h-[calc(100%-10rem)] lg:w-3xl" isOpen onClose={onClose}>
            <DialogHeader onClose={onClose}>{formatMessage(messages.headline)}</DialogHeader>
            <DialogContent className="bg-color-grey-light w-full flex-1 p-0">
              <ForgottenPasswordForm onClose={onClose} />
            </DialogContent>
          </Dialog>,
          document.body,
        )}
    </>
  );
};
